module.exports = __webpack_public_path__ + "34bc775d/img/link-icon.fa09ed66.svg";